import { Button, Tooltip } from "@mui/material";
import { SiMicrosoftexcel } from "react-icons/si";
import * as XLSX from "xlsx";

import { priceToString } from "../../../shared/utils/format-money";
import { formatFullDateTime } from "../../../shared/utils/format-date";
import { OrderRow, paymentLabel } from "./orderTypes";

type OrdersExportButtonProps = {
	orders: OrderRow[];
};

export function OrdersExportButton({ orders }: OrdersExportButtonProps) {
	function handleExport() {
		const rows = orders.map((order) => ({
			Pedido: order.orderNumber,
			Data: formatFullDateTime(order.date),
			Cliente: order.client,
			Situação: order.status,
			"Tipo de Consulta": order.queryType,
			Placa: order.plate,
			"Valor (R$)": priceToString(order.value),
			Pagamento: paymentLabel[order.payment],
		}));

		const worksheet = XLSX.utils.json_to_sheet(rows);
		const workbook = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(workbook, worksheet, "Pedidos");
		XLSX.writeFile(
			workbook,
			`pedidos-web-${new Date().toISOString().slice(0, 10)}.xlsx`,
		);
	}

	return (
		<Tooltip
			title={
				orders.length === 0 ? "Selecione ao menos um pedido para exportar" : ""
			}
		>
			<span>
				<Button
					variant="outlined"
					color="success"
					startIcon={<SiMicrosoftexcel />}
					onClick={handleExport}
					disabled={orders.length === 0}
					sx={{ textTransform: "none" }}
				>
					Exportar{orders.length > 0 ? ` (${orders.length})` : ""}
				</Button>
			</span>
		</Tooltip>
	);
}
